import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';

const RULE_TYPES = [
  { value: 'request_header', label: 'Request Header' },
  { value: 'request_body', label: 'Request Body' },
  { value: 'response_header', label: 'Response Header' },
  { value: 'response_body', label: 'Response Body' }
];

const MatchReplaceEditor = ({ rules, onChange, isDarkMode, disabled }) => {
  const handleAdd = () => {
    onChange([...rules, { enabled: true, type: 'response_header', match: '', replace: '', comment: '' }]);
  };

  const handleRemove = (idx) => {
    onChange(rules.filter((_, i) => i !== idx));
  };

  const handleUpdate = (idx, field, value) => {
    const updated = rules.map((r, i) => i === idx ? { ...r, [field]: value } : r);
    onChange(updated);
  };

  const inputClass = `text-xs rounded border px-1.5 py-1 font-mono ${isDarkMode ? 'bg-gray-900 border-gray-600 text-gray-300' : 'bg-gray-50 border-gray-300 text-gray-700'}`;
  const selectClass = `text-xs rounded border px-1 py-1 ${isDarkMode ? 'bg-gray-900 border-gray-600 text-gray-300' : 'bg-gray-50 border-gray-300 text-gray-700'}`;

  return (
    <div className="space-y-2">
      {rules.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className={isDarkMode ? 'text-gray-500' : 'text-gray-400'}>
                <th className="w-8 px-1 py-1"></th>
                <th className="text-left px-1 py-1">Type</th>
                <th className="text-left px-1 py-1">Match (regex)</th>
                <th className="text-left px-1 py-1">Replace</th>
                <th className="text-left px-1 py-1">Comment</th>
                <th className="w-8 px-1 py-1"></th>
              </tr>
            </thead>
            <tbody>
              {rules.map((rule, idx) => (
                <tr key={idx} className={`${isDarkMode ? 'border-gray-700' : 'border-gray-200'} border-b`}>
                  <td className="px-1 py-1 text-center">
                    <input
                      type="checkbox"
                      checked={rule.enabled}
                      onChange={e => handleUpdate(idx, 'enabled', e.target.checked)}
                      className="rounded"
                      disabled={disabled}
                    />
                  </td>
                  <td className="px-1 py-1">
                    <select
                      value={rule.type}
                      onChange={e => handleUpdate(idx, 'type', e.target.value)}
                      className={selectClass}
                      disabled={disabled}
                    >
                      {RULE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                  </td>
                  <td className="px-1 py-1">
                    <input
                      type="text"
                      value={rule.match}
                      onChange={e => handleUpdate(idx, 'match', e.target.value)}
                      className={`w-full ${inputClass}`}
                      placeholder="regex pattern"
                      disabled={disabled}
                    />
                  </td>
                  <td className="px-1 py-1">
                    <input
                      type="text"
                      value={rule.replace}
                      onChange={e => handleUpdate(idx, 'replace', e.target.value)}
                      className={`w-full ${inputClass}`}
                      placeholder="replacement"
                      disabled={disabled}
                    />
                  </td>
                  <td className="px-1 py-1">
                    <input
                      type="text"
                      value={rule.comment || ''}
                      onChange={e => handleUpdate(idx, 'comment', e.target.value)}
                      className={`w-full ${inputClass}`}
                      placeholder="note"
                      disabled={disabled}
                    />
                  </td>
                  <td className="px-1 py-1 text-center">
                    <button
                      onClick={() => handleRemove(idx)}
                      className="text-red-500/60 hover:text-red-400"
                      disabled={disabled}
                    >
                      <FontAwesomeIcon icon={faTrash} className="text-[10px]" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <button
        onClick={handleAdd}
        disabled={disabled}
        className={`flex items-center gap-1.5 text-xs px-2 py-1 rounded ${isDarkMode ? 'text-teal-400 hover:bg-gray-700' : 'text-teal-600 hover:bg-gray-100'} disabled:opacity-50`}
      >
        <FontAwesomeIcon icon={faPlus} /> Add Rule
      </button>
    </div>
  );
};

export default MatchReplaceEditor;
